export const actionState = {
  isUndo: false,
  isRedo: false,
};
